// BottomNavigation.js
import React, { useContext } from 'react';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import ChecklistRtlIcon from '@mui/icons-material/ChecklistRtl';
import PeopleIcon from '@mui/icons-material/People';
import SettingsIcon from '@mui/icons-material/Settings';

import { Link } from 'react-router-dom';
import userContext from "../../context/user-context";
import UploadCard from '../UploadCard/UploadCard';

const BottomNav = () => {
  const { role } = useContext(userContext);

  return (
    <BottomNavigation style={{ position: 'fixed', bottom: 0, width: '100%', background: '#354a5f', zIndex: 9999, paddingTop: 8 }}>
      {/* Home icon with link to / */}
      <BottomNavigationAction label="Home" icon={<HomeIcon style={{ color: 'white' }} />} component={Link} to="/" />

       {/* Camera icon (with a circular background) */}
      {window.location.pathname === '/scan' && (
        <BottomNavigationAction
          label="Camera"
          icon={
            <div style={{ borderRadius: '50%', background: '#fff', padding: 8 }} onClick={UploadCard.openCamera}>
              <PhotoCameraIcon style={{ color: '#354a5f' }} />
            </div>
          }
        />
      )}
      

      {window.location.pathname !== '/scan' && (
        <BottomNavigationAction
          label="New scan"
          icon={
            <div style={{ borderRadius: '50%', background: '#fff', padding: 8 }}>
              <PhotoCameraIcon style={{ color: '#354a5f' }} />
            </div>
          }
          component={Link} to="/scan"
        />
      )}


      {/* History icon with link to /history */}
      <BottomNavigationAction
        label="All scans"
        icon={<ChecklistRtlIcon style={{ color: 'white' }} />}
        component={Link}
        to="/history"
      />

      {/* Users icon with link to /users (conditionally rendered) */}
      {role === 'admin' && (
        <BottomNavigationAction
          label="Users"
          icon={<PeopleIcon style={{ color: 'white' }} />}
          component={Link}
          to="/users"
        />
      )}
	  
	  
	  
	  {/* Users icon with link to /settings (conditionally rendered) */}
      {role === 'admin' && (
        <BottomNavigationAction
          label="Settings"
          icon={<SettingsIcon style={{ color: 'white' }} />}
          component={Link}
          to="/settings"
        />
      )}
	  
    </BottomNavigation>
  );
};

export default BottomNav;

